import { render, staticRenderFns } from "./BatchSummary.vue?vue&type=template&id=6f07de56&scoped=true&"
import script from "./BatchSummary.vue?vue&type=script&lang=js&"
export * from "./BatchSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07de56",
  null
  
)

export default component.exports